var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 253,
    viewBox: "0 0 256 253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M7.807 3.972C5.26 4.32 3.255 2.777.882 1.841c1.46 1.878 3.175 3.325 3.668 5.577.471 1.432.025 2.775-.499 4.082-.42 1.055-.953 2.065-1.565 3.373 1.392-1.014 2.403-2.028 3.6-2.812 1.702-1.113 3.458-1.335 5.343-.668 1.287.453 2.51 1.04 3.704 1.688.366-.261-.114-.37-.097-.567-.53-.622-1.1-1.217-1.584-1.873-.817-1.114-1.65-2.24-1.673-3.725-.29-2.484 1.242-4.426 2.15-6.77C11.9 1.72 10.313 3.63 7.807 3.972z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__c",
    d: "M7.576 6.418c-2.442 1.02-4.844.013-7.452-.29C2.072 7.61 4.16 8.595 5.248 10.706c.844 1.3.757 2.753.58 4.194-.14 1.159-.401 2.305-.668 3.77 1.119-1.377 1.856-2.654 2.841-3.75 1.398-1.555 3.086-2.241 5.14-2.077 1.398.112 2.769.373 4.13.703.295-.358-.21-.34-.245-.54-.694-.477-1.418-.92-2.07-1.444-1.11-.894-2.233-1.794-2.65-3.266-.945-2.393.067-4.732.35-7.302-1.602 2.102-2.675 4.42-5.08 5.423z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__e",
    d: "M15.16 11.154c-4.809 2.005-9.536.026-14.67-.575 3.835 2.922 7.945 4.863 10.085 9.016 1.664 2.562 1.49 5.421 1.145 8.255-.277 2.284-.794 4.538-1.315 7.422 2.2-2.713 3.656-5.225 5.59-7.38 2.752-3.064 6.075-4.414 10.117-4.089 2.753.22 5.452.732 8.132 1.381.578-.703-.415-.664-.485-1.059-1.364-.943-2.79-1.811-4.076-2.846-2.181-1.755-4.393-3.528-5.213-6.426-1.86-4.712.132-9.315.69-14.374-3.156 4.138-5.27 8.7-10 10.675z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__g",
    d: "M3.008 5.269c.143 1.101-.363 2.014-.923 2.89-.451.708-.975 1.368-1.6 2.234 1.15-.546 2.024-1.142 3-1.547 1.385-.574 2.688-.493 3.965.249.871.504 1.677 1.099 2.455 1.733.301-.14-.03-.284.007-.424-.299-.525-.63-1.034-.89-1.577-.441-.92-.89-1.85-.702-2.932.129-1.84 1.507-3.04 2.487-4.614-1.688.863-3.1 2.03-4.966 1.935-1.894-.098-3.137-1.492-4.73-2.498.802 1.565 1.847 2.85 1.897 4.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__i",
    d: "M1.846 3.833c.103.783-.257 1.429-.653 2.052C.872 6.387.5 6.855.058 7.47c.814-.387 1.435-.81 2.126-1.096.985-.408 1.91-.351 2.816.175.618.359 1.19.78 1.742 1.23.214-.1-.022-.202.006-.302-.213-.372-.45-.733-.634-1.118-.313-.653-.63-1.313-.497-2.08.091-1.306 1.07-2.158 1.766-3.275-1.2.613-2.201 1.44-3.525 1.373C2.513 2.306 1.632 1.317.5.604c.57 1.11 1.31 2.02 1.345 3.23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__j",
    d: "M2.552 3.817c.063.77-.32 1.383-.739 1.973-.336.473-.722.914-1.186 1.492.815-.338 1.442-.723 2.132-.969.981-.348 1.882-.248 2.743.312.585.38 1.124.82 1.64 1.286.213-.086-.012-.197.02-.293-.189-.374-.401-.74-.562-1.124-.273-.654-.552-1.314-.384-2.058.153-1.271 1.15-2.055 1.886-3.113-1.2.54-2.222 1.299-3.511 1.168C3.279 2.358 2.466 1.348 1.398.595c.5 1.113 1.18 2.04 1.154 3.222z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__l",
    d: "M0 0.021L18.203 0.021 18.203 12.757 0 12.757z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__n",
    d: "M0.104 0.021L18.306 0.021 18.306 12.757 0.104 12.757z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF2F8",
    d: "M127.378 158.911H221.136V204.995H127.378z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE3F4",
    d: "M68.9 187.486c2.14.667 4.147 1.359 6.031 2.071-2.284-3.993-3.772-6.779-4.236-7.658-.686 2.26-1.314 4.172-1.795 5.587M217.744 198.888c.008-.071-.01-.067-.037-.03.015.085.027.116.037.03M215.732 203.82c.001.036.005.068.007.104 1.035-2.834 1.802-4.849 1.968-5.066-.134-.783-.46-8.494-.775-16.643-.286 3.114-.599 6.67-.94 10.727-.355 4.219-.42 7.787-.26 10.878",
    transform: "translate(0 .29)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEEF3",
    d: "M214.202 113.352c-7.713-1.89-17.24-5.746 12.537-54.33 29.777-48.58-106.566-94.551-183.88-17.76C-32.075 115.69 3.404 167.8 57.026 184.13c1.426-19.212 16.81-41.545 16.81-41.545.035.06.062.13.096.19 4.007-2.374 16.235-4.425 16.235-4.425l.83-6.366s10.295-.738 15.022 5.814c4.725 6.554 17.092 6.778 17.092 6.778-.768 3.607-1.685 9.553-1.685 9.553-3.06 23.325 17.685 93.526 18.79 97.24 3.023-.27 6.265-.665 9.737-1.192.053-.2.126-.403.222-.613 6.697-14.503-1.398-58.667 1.169-74.285 2.566-15.617-7.914-37.205-7.914-37.205 25.437-22.203 70.868-7.938 70.868-7.938s.161.41.423 1.13c.104-.831.268-1.256.51-1.13 26.486 13.713 18.654 77.465 13.932 94.26 48.372-28.314 23.15-110.512-14.96-111.044",
    transform: "translate(0 .29)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4888EF",
    d: "M121.426 154.129s.917-5.945 1.685-9.552c0 0-12.367-.225-17.092-6.778-4.725-6.553-15.02-5.816-15.02-5.816l-.832 6.368s-12.228 2.05-16.235 4.424c4.852 8.67.132 28.026-3.237 39.124.465.879 1.952 3.665 4.236 7.658 32.851 12.41 24.105 19.59 25.163 37.518 1.06 17.927 20.686 22.352 30.796 24.767 2.851-.02 5.957-.171 9.326-.473-1.105-3.715-21.85-73.914-18.79-97.24",
    transform: "translate(0 .29)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBDC5",
    d: "M70.534 181.59c10.863-32.05 3.238-38.728 3.238-38.728.047-.03.11-.059.16-.086-.035-.062-.061-.131-.097-.19 0 0-11.403 1.82-16.81 41.545 1.704.518 3.426 1.001 5.162 1.447 2.374.61 4.602 1.248 6.713 1.908.48-1.414 1.108-3.326 1.795-5.588l-.161-.307",
    transform: "translate(0 .29)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAFCE",
    d: "M70.534 181.59l.16.308c3.37-11.097 8.09-30.451 3.238-39.122-.05.027-.113.057-.16.086 0 0 5.26 8.796-3.238 38.729",
    transform: "translate(0 .29)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6E6E6E",
    d: "M214.72 131.265c-.715 5.726-.818 29.774-.818 29.774s3.43 1.315 3.804 11.02c.316 8.15-.133 26.016 0 26.798-.165.219-.933 2.233-1.967 5.068.125 2.32.375 4.373.73 6.227 1.399 7.326 4.379 11.57 7.281 17.234 1.89-.983 3.688-1.98 5.413-2.99 4.722-16.795 12.554-80.546-13.932-94.26-.242-.126-.406.298-.51 1.129z",
    transform: "translate(0 .29)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFBDC5",
    d: "M27.287 94.254c1.013 1.375 10.787 6.895 21.714 13.063 4.334 2.445 4.924 8.525 9.183 10.973-4.195-3.858-15.558-20.57-15.558-20.57s-4.44-16.086-2.76-17.642c.851-.787 4.079-.054 5.454.699 2.197 1.204 16.846 16.364 22.27 33.194 2.089 3.44 2.192 11.307-2.578 11.716-2.281.195-6.268 1.789-9.445.285-14.554-6.884-32.083-36.88-28.28-31.718M15.413 39.038s15.64-4.42 17.319 9.106C34.41 61.669 30.73 73.403 28.226 74c-2.502.596-14.401 4.075-22.554-18.173-8.154-22.248 9.74-16.79 9.74-16.79M76.955 13.825s19.061 4.663 20.741 18.189c1.678 13.524-9.44 25.809-11.943 26.406-2.502.598-6.962 3.525-15.117-18.723-8.154-22.25 6.32-25.872 6.32-25.872",
    transform: "translate(77.855 63.813)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M31.198 42.031c1.179 3.932-10.073 4.071-15.479 8.335-4.578 3.61-5.449 12.686-5.348 14.54.405 7.507-10.29-11.739-10.29-19.254 0-7.515 9.12-11.541 17.525-11.541 8.406 0 12.207 3.298 13.592 7.92",
    transform: "translate(77.855 63.813)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M137.883 140.402c-.001-.036-.004-.07-.007-.105-.16-3.09-.094-6.66.26-10.876.342-4.059.656-7.616.94-10.73-.374-9.704-1.7-21.284-1.7-21.284s-.715-25.068 0-30.794c-.262-.72-46.365-14.265-71.8 7.938 0 0 10.478 21.588 7.912 37.205-2.566 15.618 5.528 59.783-1.167 74.285-.097.21-.17.414-.222.613 9.978-1.523 21.859-4.164 36.039-8.285 14.472-4.206 26.529-8.835 36.421-13.838.44-.224.903-.444 1.336-.669-2.903-5.663-5.882-9.907-7.28-17.232-.355-1.854-.607-3.907-.732-6.228z",
    transform: "translate(77.855 63.813)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6E6E6E",
    d: "M65.575 74.551s-31.2 33.201-10.874 68.62c20.327 35.418 59.133 18.478 59.133 18.478l-4.638-5.449s-36.905-11.637-38.273-28.825c-1.37-17.19 2.566-15.619 2.566-15.619s5.424-29.445-7.914-37.205",
    transform: "translate(77.855 63.813)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBDC5",
    d: "M105.735 161.345c-2.632 2.902-.76 5.129 5.616 6.68 5.63-1.118 10.273-4.83 13.929-11.136 5.484-9.46-15.597.102-19.545 4.456z",
    transform: "translate(77.855 63.813)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC6D6",
    d: "M98 165.435s19.32 5.371 32.335-3.152l10.172-21.57s-35.553 7.313-41.34 7.434l-1.166 17.288z",
    transform: "translate(77.855 63.813)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF8DAD",
    d: "M98.36 165.435s-10.304-19.028-11.082-30.845l1.716-21.057 11.433 33.578-2.068 18.324z",
    transform: "translate(77.855 63.813)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEDF3",
    d: "M100.051 147.988s26.404 2.879 40.456-7.275l-12.56-35.785s-21.64 8.306-38.953 8.606l11.057 34.454z",
    transform: "translate(77.855 63.813)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6E0020",
    d: "M105.735 111.336c1.801-1.481 3.922-1.975 6.363-1.481 2.44.494 3.397 6.27 2.868 17.326-1.418 4.697-2.514 4.915-3.289.654-.774-4.26-2.755-9.76-5.942-16.499z",
    transform: "translate(77.855 63.813)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B31240",
    d: "M114.75 124.26c11.76-3.91 17.758-5.758 17.997-5.545.238.212.862 1.955 1.872 5.228l-19.868 3.524v-3.207zM89.527 145.246L93.853 128.582 112.253 125.147 113.252 129.417 95.691 134.274 91.802 151.227z",
    transform: "translate(77.855 63.813)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAFCE",
    d: "M87.138 55.117V57.6l-.236 5.91s2.808-2.975 10.056-2.975c7.248 0 14.389 1.054 14.389 1.054s-2.223.577-4.123-7.415c-.362-1.523-.644-3.276-.804-5.295-.992-12.62-19.99 2.694-19.282 6.238",
    transform: "translate(77.855 63.813)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6E6E6E",
    d: "M87.137 56.362l-.744 7.814s9.161-2.693 27.033-2.032c0 0-4.877-5.847-5.571-8.924 0 0-14.025-.37-20.718 3.142z",
    transform: "translate(77.855 63.813)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M101.545 2.452S61.08-8.089 65.678 16.652c0 0-1.807 12.149 9.774 16.015 11.58 3.866 5.114 9.02 5.114 9.02s2.255-7.357 4.06-3.494c1.805 3.861-3.158.971-2.556 5.086.601 4.114.903 14.607 10.829 14.975 9.925.367 6.917-8.285 9.925-5.34 3.007 2.946 11.28-16.197 9.023-18.957-2.255-2.762 1.956-11.23 1.956-11.23S120.857.22 101.545 2.451",
    transform: "translate(77.855 63.813)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBDC5",
    d: "M27.394 96.529s-13.646-4.612-12.032-7.675c1.612-3.063 7.977-6.718 7.447-7.689-.527-.97 10.386 13.778 4.585 15.364",
    transform: "translate(77.855 63.813)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(182.997 39.728)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1.432 -8.893L19.554 5.198 5.169 23.698 -12.953 9.607z",
    mask: "url(#prefix__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.362 147.932)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M2.578 -5.957L24.331 3.277 14.905 25.482 -6.847 16.248z",
    mask: "url(#prefix__d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(86.191 35.025)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.322 -13.205L48.139 4.969 29.585 48.678 -13.232 30.503z",
    mask: "url(#prefix__f)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(152.756 172.588)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.441 -6.335L17.651 6.371 4.679 17.814 -6.53 5.108z",
    mask: "url(#prefix__h)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(197.196 222.593)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M87.279 99.412c0 4.328-3.508 7.834-7.835 7.834-4.328 0-7.836-3.506-7.836-7.834 0-4.328 3.508-7.835 7.836-7.835 4.327 0 7.835 3.507 7.835 7.835"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.12 162.849)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__k",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__j"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.339 -4.111L12.669 5.091 3.276 12.574 -4.055 3.372z",
    mask: "url(#prefix__k)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#720C29",
    d: "M192.273 230.918c3.044-11.718 4.419-18.155 4.123-19.311-.443-1.734-2.687-18.154-5.931-19.383-2.163-.82-.564-1.135 4.799-.944 4.902 10.55 7.12 17.147 6.652 19.792-.701 3.968-2.977 19.299-3.372 19.299-.264 0-2.354.182-6.27.547z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M39.233 117.171c-3.158.117-5.46-1.97-8.275-3.375 1.6 2.428 3.557 4.367 3.938 7.13.432 1.776-.25 3.335-1.022 4.844-.622 1.217-1.375 2.367-2.26 3.868 1.81-1.056 3.153-2.155 4.697-2.954 2.197-1.136 4.373-1.198 6.619-.175 1.53.696 2.97 1.544 4.371 2.464.474-.272-.102-.457-.062-.692-.589-.81-1.228-1.592-1.754-2.437-.891-1.433-1.797-2.883-1.677-4.67-.108-3.017 1.967-5.17 3.313-7.877-2.645 1.652-4.78 3.758-7.888 3.874z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-8 1382.453 -1140.191) translate(.06 .022)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B31240",
    d: "M17.189 32.36c-.087-.08-2.84-2.645-5.23-3.463-2.426-.83-3.91-.416-3.887-1.571.012-.586.204-2.34.593-4.193.38-1.803.946-3.7 1.714-4.706 1.557-2.04 5.826-5.893 7.885-6.386l.051 1.004.03.579s-2.592 3.557-2.851 7.582c-.256 3.981 1.653 10.996 1.695 11.154"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#880027",
    d: "M18.345 13.063l-.922.747s-5.887 6.154-8.618 9.52c.376-1.836.935-3.767 1.695-4.79 1.539-2.076 5.759-5.998 7.794-6.499l.05 1.022z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B31240",
    d: "M18.345 13.624s2.592 3.556 2.85 7.581C21.456 25.23 19.5 32.36 19.5 32.36s2.804-2.635 5.23-3.465c2.428-.83 3.912-.416 3.889-1.57-.024-1.156-.749-6.86-2.307-8.9-1.558-2.04-5.827-5.891-7.886-6.384l-.08 1.583z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#880027",
    d: "M18.243 13.112l.922.746s5.886 6.155 8.617 9.52c-.375-1.836-.934-3.767-1.694-4.79-1.54-2.076-5.76-5.997-7.795-6.499l-.05 1.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B31240",
    d: "M17.611 13.225s-6.378 6.13-8.933 6.987c-2.554.858-7.982-3.56-2.933-8.642 5.05-5.082 11.866-.965 11.866-.965v2.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#880027",
    d: "M4.403 13.816c.838 1.949 3.23 3.096 4.686 2.64 2.172-.68 7.121-4.927 8.522-6.155-1.49-.711-7.118-2.971-11.444 1.088-.89.835-1.455 1.653-1.764 2.427"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__l"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6E0020",
    d: "M17.56 8.927S10.614 1.277 7.013.1C3.412-1.078-5.334 11.45 4.569 12.543c9.904 1.093 13.634-2.355 13.634-2.355l-.643-1.26z",
    mask: "url(#prefix__m)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B31240",
    d: "M19.079 13.225s6.378 6.13 8.932 6.987c2.555.858 7.983-3.56 2.933-8.642-5.049-5.082-11.865-.965-11.865-.965v2.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#880027",
    d: "M33.02 13.816c-.838 1.949-3.23 3.096-4.685 2.64-2.172-.68-7.122-4.927-8.523-6.155 1.49-.711 7.119-2.971 11.444 1.088.89.835 1.455 1.653 1.765 2.427"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.079)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__o",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__n"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6E0020",
    d: "M.747 8.927S7.692 1.277 11.293.1c3.601-1.177 12.348 11.35 2.444 12.444C3.834 13.636.104 10.188.104 10.188l.643-1.26z",
    mask: "url(#prefix__o)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B31240",
    d: "M33.816 8.443c-8.855 3.65-14.004 1.417-14.004 1.417l.005-.47.257-.496S27.092 1.254 30.73.078c1.642-.53 4.341 1.724 5.89 4.46.308 1.496-.398 2.913-2.805 3.905M3.607 8.443c8.855 3.65 14.004 1.417 14.004 1.417l-.005-.47-.256-.496S10.33 1.254 6.692.078C5.05-.452 2.35 1.802.802 4.538.493 6.033 1.2 7.45 3.606 8.442"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E27489",
    d: "M18.712 9.03c-2.678 0-2.568 1.18-2.568 2.635 0 1.454.16 2.634 2.568 2.634 2.407 0 2.567-1.18 2.567-2.634 0-1.455.11-2.634-2.567-2.634"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED88A0",
    d: "M21.28 9.997c-.09 1.177-.536 2.044-2.568 2.044-2.034 0-2.479-.867-2.569-2.044.089-1.009.52-1.719 2.569-1.719 2.047 0 2.48.71 2.568 1.719"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCard);
export default __webpack_public_path__ + "static/media/gift-card.b445754b3462df084bcf78526ae9aa82.svg";
export { ForwardRef as ReactComponent };